export const CoreDataSecurityApplicationsAllName = 'CoreDataSecurityApplicationsAll';
